import React from 'react';

const NoResultsImage: React.FC = () => {
  return <img src="/images/noResults.svg" alt="No Results" />;
};

export default NoResultsImage;
